import { rowsType } from '.'

export const selectedInterventionBlock = (breadCrumbs: BreadCrumbState, wellIndex: number, index: number): string => {
    return `${
        breadCrumbs.wellIndex === wellIndex &&
        breadCrumbs.selected.type === rowsType[0] &&
        breadCrumbs.intervention === index
            ? 'selected'
            : ''
    }`
}

export const selectedSectionBlock = (
    breadCrumbs: BreadCrumbState,
    wellIndex: number,
    index: number,
    section_index: number
): string => {
    return `${
        breadCrumbs.wellIndex === wellIndex &&
        breadCrumbs.selected.type === rowsType[1] &&
        breadCrumbs.intervention === index &&
        breadCrumbs.section_phase === section_index
            ? 'selected'
            : ''
    }`
}

export const selectedRunBlock = (
    breadCrumbs: BreadCrumbState,
    wellIndex: number,
    index: number,
    section_index: number,
    run_index: number
): string => {
    return `${
        breadCrumbs.wellIndex === wellIndex &&
        breadCrumbs.selected.type === rowsType[2] &&
        breadCrumbs.intervention === index &&
        breadCrumbs.section_phase === section_index &&
        breadCrumbs.run === run_index
            ? 'selected'
            : ''
    }`
}
